var _ = require('underscore');
var lightClone = require('./utility/clone').lightClone;

/**
 * Private method returning whether libraryConfigurations permits this feature.
 * @param {obj} libraryConfigurations - The library configurations
 * @param {string} feature - The feature in question
 * @returns {boolean}
 */
var _okForLibrary = function(libraryConfigurations, feature) {
    const libFeat = libraryConfigurations[feature];
    return !libFeat || libFeat.enabled || false;
};

/**
 * Private method returning whether to use the config/features.json
 * `enabled` or `testable` value.
 * @param {number} tenant - The tenant id
 * @param {string} allFeatures - The allFeatures secret cookie value
 * @returns {boolean}
 */
var _shouldUseTestable = function(tenant, allFeatures) {
    return tenant === 100501 || tenant === 800004 || tenant === 800005 || allFeatures === '1';
};

/**
 * Feature manager
 * @constructor
 * @param {obj} libraryConfigurations - The library configurations
 * @param {number} tenant - The tenant id
 * @param {string} allFeatures - The allFeatures secret cookie value
 * @param {array} dynamicConfigurationFunctions - The allFeatures sec
 */
function FeatureManager(feats, libraryConfigurations, tenant, allFeatures, dynamicConfigurationFunctions) {
    this.useTestable = _shouldUseTestable(tenant, allFeatures);
    this.okForLibrary = _.partial(_okForLibrary, libraryConfigurations);
    var features = lightClone(feats);
    dynamicConfigurationFunctions && dynamicConfigurationFunctions.forEach(function(item) {
        features = item.configureDynamicFeature(features, libraryConfigurations, tenant, allFeatures);
    });
    this.features = features;
}

/**
 * Feature manager method for determining whether or not to show a feature.
 * This is the single source of truth for permissions.
 * @method
 * @param {string} feature - The feature in question
 * @returns {boolean}
 */
FeatureManager.prototype.isEnabled = function(feature) {
    return !!(this.okForLibrary(feature) && (this.useTestable ?
        this.isStrictlyTestable(feature) : this.isStrictlyEnabled(feature)));
};

/**
 * Feature manager method returning the strictly `enabled` value.
 * Note: due to dynamic configurations, this should not be assumed to be
 * the config/features.json `enabled` value, though that is the default.
 * @param {string} feature - The feature to lookup
 * @returns {boolean}
 */
FeatureManager.prototype.isStrictlyEnabled = function(feature) {
    return this.features[feature] && this.features[feature].enabled;
};

/**
 * Feature manager method returning the strictly `testable` value.
 * Note: due to dynamic configurations, this should not be assumed to be
 * the config/features.json `enabled` value, though that is the default.
 * @param {string} feature - The feature to lookup
 * @returns {boolean}
 */
FeatureManager.prototype.isStrictlyTestable = function(feature) {
    return this.features[feature] && this.features[feature].testable;
};


module.exports = FeatureManager;
